__turbopack_context__.v({
  "desktop": "styles-module-scss-module__YeYPBq__desktop",
  "image": "styles-module-scss-module__YeYPBq__image",
  "mobile": "styles-module-scss-module__YeYPBq__mobile",
  "pageBanner": "styles-module-scss-module__YeYPBq__pageBanner",
  "slider": "styles-module-scss-module__YeYPBq__slider",
});
